module.exports = "/_next/static/images/dd295b441ed10d8750d5a1d2c70a437a-calendar3d.png";